import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Locator } from '@readium/shared';
import type { Bookmark } from '../../../models/selections';
import { ReaderNavigatorService } from '../../../services/readium/navigator/reader-navigator';
import { BookmarksService } from '../../../services/selections/bookmarks';

@Component({
  selector: 'nr-bookmarks',
  imports: [TranslatePipe, DecimalPipe],
  templateUrl: './bookmarks.html',
  styleUrl: './bookmarks.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BookmarksComponent {
  private static readonly INSTANCE_ID_LENGTH = 8;

  private readonly bookmarksService = inject(BookmarksService);
  private readonly readerNavigatorService = inject(ReaderNavigatorService);
  private readonly instanceId = crypto.randomUUID().slice(0, BookmarksComponent.INSTANCE_ID_LENGTH);

  readonly bookmarks = this.bookmarksService.bookmarks;
  readonly nrNavigated = output();

  triggerId(bookmarkId: string): string {
    return `navigation-bookmark-button-${this.instanceId}-${bookmarkId}`;
  }

  navigateToBookmark(bookmark: Bookmark): void {
    const bookMarkLocator = Locator.deserialize(bookmark.locator);
    if (!bookMarkLocator) return;
    this.readerNavigatorService.goToLocator(bookMarkLocator);
    this.nrNavigated.emit();
  }

  deleteBookmark(bookmark: Bookmark): void {
    this.bookmarksService.removeBookmark(bookmark.id);
    this.nrNavigated.emit();
  }
}
